import { GabaritoAdsQuestionElement } from "./interface";
import { createInterstitial, createOverlay } from "./create";

export function cleanupPreviousGabaritoAds(excludeElementId: string | null = null, isMobile: boolean = false): void {
    const existingModal = document.getElementById('intersticial-modal');
    if (existingModal && existingModal.id !== excludeElementId) {
        if ((existingModal as any).mobileCloseEnableTimerId) clearTimeout((existingModal as any).mobileCloseEnableTimerId);
        if ((existingModal as any).mobileCountdownIntervalId) clearInterval((existingModal as any).mobileCountdownIntervalId);

        const adPlacement = existingModal.querySelector('.ad-placement-area-dynamic');
        const adUnit = existingModal.dataset.adUnitPath;
        if (adPlacement && adUnit && typeof window.Sg_GPT_onTriggerRemoveCallback === 'function') {
            window.Sg_GPT_onTriggerRemoveCallback(adPlacement as HTMLElement, [adUnit]);
        }

        existingModal.remove();
        document.body.style.overflow = 'auto';
    }

    document.querySelectorAll('.ad-gabarito__overlay, .hidden-content-ad__overlay').forEach(overlay => {
        const parentWrapper = overlay.closest('.multiple-choice-wrapper, .hidden-content');
        setTimeout(() => {
            if (parentWrapper && (!excludeElementId || parentWrapper.id !== excludeElementId)) {
                if ((overlay as any).closeTimerId) clearTimeout((overlay as any).closeTimerId);
                if ((overlay as any).countdownIntervalId) clearInterval((overlay as any).countdownIntervalId);
                if ((overlay as any).labelEnableTimerId) clearTimeout((overlay as any).labelEnableTimerId);

                let adUnit = (overlay as HTMLElement).dataset.adUnitPath || window.sg_gabarito_ads_config.adUnitPathDesk;
                if(isMobile) {
                    adUnit = (overlay as HTMLElement).dataset.adUnitPath || window.sg_gabarito_ads_config.adUnitPathMob;
                }

                if (typeof window.Sg_GPT_onTriggerRemoveCallback === 'function') {
                    window.Sg_GPT_onTriggerRemoveCallback(overlay as HTMLElement, [adUnit]);
                }

                const answerElement = parentWrapper.querySelector('.answer-info, .answer-contents');
                if (answerElement) {
                    (answerElement as HTMLElement).style.cssText = '';
                    if (parentWrapper.classList.contains('hidden-content')) {
                        const config = window.sg_gabarito_ads_config.GabaritoAdsQuestionElements.find(el => el.id === parentWrapper.id);
                        if (config?.checkboxSelector) {
                            const checkbox = document.querySelector(config.checkboxSelector) as HTMLInputElement;
                            if (checkbox) checkbox.disabled = false;
                        }
                    }
                }

                if (document.body.contains(overlay)) {
                    overlay.remove();
                }
            }
        }, 1);
    });
}

export function displayGabaritoAd(
    questionConfig: GabaritoAdsQuestionElement,
    isMobile: boolean,
    targetAnswerElement: HTMLElement,
    questionWrapperElement: HTMLElement
): void {
    createOverlay(
        isMobile ? window.sg_gabarito_ads_config.adUnitPathMob : window.sg_gabarito_ads_config.adUnitPathDesk,
        targetAnswerElement,
        questionWrapperElement,
        questionConfig
    );
}